// eslint-disable-next-line import/prefer-default-export
export const LOAD_PARTNERS = 'LOAD_PARTNERS';
export const SET_PARTNER_FILTER = 'SET_PARTNER_FILTER';
export const SET_PARTNER_PAGINATION = 'SET_PARTNER_PAGINATION';
export const SET_PARTNER_SORT = 'SET_PARTNER_SORT';
export const ADD_NEW_PARTNER = 'ADD_NEW_PARTNER';
export const EDIT_PARTNER = 'EDIT_PARTNER';
export const SET_EMPTY_EDITABLE_PARTNER = 'SET_EMPTY_EDITABLE_PARTNER';
export const LOAD_EDITABLE_PARTNER = 'LOAD_EDITABLE_PARTNER';
